var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "emergency-address-panel" },
    [
      _c(
        "v-card",
        { staticClass: "panel-container", attrs: { flat: "" } },
        [
          !_vm.loading && !_vm.report && !_vm.error
            ? _c(
                "div",
                { staticClass: "initial-state" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mb-4",
                      attrs: { size: "48", color: "red darken-1" },
                    },
                    [_vm._v("mdi-shield-alert-outline")]
                  ),
                  _c("h3", { staticClass: "initial-title" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("emergency-address-compliance")) + " "
                    ),
                  ]),
                  _c("p", { staticClass: "initial-description" }, [
                    _vm._v(
                      " " + _vm._s(_vm.$t("emergency-report-description")) + " "
                    ),
                  ]),
                  _c(
                    "v-btn",
                    {
                      staticClass: "generate-btn",
                      attrs: {
                        color: "red darken-1",
                        dark: "",
                        large: "",
                        rounded: "",
                      },
                      on: { click: _vm.fetchReport },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-file-document-outline"),
                      ]),
                      _vm._v(" " + _vm._s(_vm.$t("generate-report")) + " "),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm.loading
            ? _c(
                "div",
                { staticClass: "loading-container" },
                [
                  _c("v-progress-circular", {
                    attrs: { indeterminate: "", color: "red darken-1" },
                  }),
                  _c("span", { staticClass: "loading-text" }, [
                    _vm._v(_vm._s(_vm.$t("loading")) + "..."),
                  ]),
                ],
                1
              )
            : _vm.error
            ? _c(
                "v-alert",
                {
                  staticClass: "ma-4",
                  attrs: { type: "error", outlined: "", dense: "" },
                },
                [_vm._v(" " + _vm._s(_vm.error) + " ")]
              )
            : _vm.report
            ? _c("div", { staticClass: "content-container" }, [
                _c(
                  "div",
                  {
                    staticClass: "queue-status",
                    class: _vm.report.isEmergencyQueueEmpty
                      ? "queue-empty"
                      : "queue-processing",
                  },
                  [
                    _c(
                      "v-icon",
                      {
                        attrs: {
                          small: "",
                          color: _vm.report.isEmergencyQueueEmpty
                            ? "green"
                            : "orange",
                        },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.report.isEmergencyQueueEmpty
                                ? "mdi-check-circle"
                                : "mdi-progress-clock"
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.report.isEmergencyQueueEmpty
                            ? _vm.$t("queue-empty")
                            : _vm.$t("queue-processing")
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _c("div", { staticClass: "summary-section" }, [
                  _c("div", { staticClass: "summary-stats" }, [
                    _c("div", { staticClass: "stat-item compliant" }, [
                      _c("span", { staticClass: "stat-value" }, [
                        _vm._v(
                          _vm._s(_vm.report.summary?.compliantPhoneNumbers || 0)
                        ),
                      ]),
                      _c("span", { staticClass: "stat-label" }, [
                        _vm._v(_vm._s(_vm.$t("compliant"))),
                      ]),
                    ]),
                    _c("div", { staticClass: "stat-item non-compliant" }, [
                      _c("span", { staticClass: "stat-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.report.summary?.nonCompliantPhoneNumbers || 0
                          )
                        ),
                      ]),
                      _c("span", { staticClass: "stat-label" }, [
                        _vm._v(_vm._s(_vm.$t("non-compliant"))),
                      ]),
                    ]),
                    _c("div", { staticClass: "stat-item total" }, [
                      _c("span", { staticClass: "stat-value" }, [
                        _vm._v(
                          _vm._s(_vm.report.summary?.totalPhoneNumbers || 0)
                        ),
                      ]),
                      _c("span", { staticClass: "stat-label" }, [
                        _vm._v(_vm._s(_vm.$t("total"))),
                      ]),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "organizations-section" },
                  [
                    _c(
                      "div",
                      { staticClass: "section-header" },
                      [
                        _c("span", { staticClass: "section-title" }, [
                          _vm._v(_vm._s(_vm.$t("organizations"))),
                        ]),
                        _c(
                          "v-chip",
                          {
                            staticClass: "org-count-chip",
                            attrs: { small: "" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.compliantOrganizationsCount) +
                                " / " +
                                _vm._s(_vm.report.organizations?.length || 0) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "search-container" },
                      [
                        _c("v-text-field", {
                          staticClass: "search-field",
                          attrs: {
                            placeholder: _vm.$t("search") + "...",
                            "prepend-inner-icon": "mdi-magnify",
                            clearable: "",
                            "hide-details": "",
                            outlined: "",
                            dense: "",
                          },
                          model: {
                            value: _vm.searchText,
                            callback: function ($$v) {
                              _vm.searchText = $$v
                            },
                            expression: "searchText",
                          },
                        }),
                        _vm.searchText
                          ? _c("div", { staticClass: "results-count" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.filteredOrganizations.length) +
                                  " " +
                                  _vm._s(
                                    _vm.filteredOrganizations.length === 1
                                      ? _vm.$t("organization").toLowerCase()
                                      : _vm.$t("organizations").toLowerCase()
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "v-expansion-panels",
                      {
                        attrs: { multiple: "", flat: "" },
                        model: {
                          value: _vm.expandedPanels,
                          callback: function ($$v) {
                            _vm.expandedPanels = $$v
                          },
                          expression: "expandedPanels",
                        },
                      },
                      _vm._l(_vm.filteredOrganizations, function (org) {
                        return _c(
                          "v-expansion-panel",
                          {
                            key: org.organizationId,
                            staticClass: "org-panel",
                            class: { "org-inactive": !org.isActive },
                          },
                          [
                            _c(
                              "v-expansion-panel-header",
                              { staticClass: "org-header" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "org-header-content" },
                                  [
                                    _c("div", { staticClass: "org-info" }, [
                                      _c(
                                        "div",
                                        { staticClass: "org-name-row" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "org-name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  org.organizationName ||
                                                    org.organizationId
                                                )
                                              ),
                                            ]
                                          ),
                                          !org.isActive
                                            ? _c(
                                                "v-chip",
                                                {
                                                  staticClass: "ml-2",
                                                  attrs: {
                                                    "x-small": "",
                                                    color: "grey",
                                                    "text-color": "white",
                                                  },
                                                },
                                                [_vm._v(" inactive ")]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "org-id-row" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "org-id" },
                                            [_vm._v(_vm._s(org.organizationId))]
                                          ),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "copy-btn",
                                              attrs: {
                                                icon: "",
                                                "x-small": "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.copyToClipboard(
                                                    org.organizationId
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { "x-small": "" } },
                                                [_vm._v("mdi-content-copy")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                    _c(
                                      "div",
                                      { staticClass: "org-status" },
                                      [
                                        _c(
                                          "v-chip",
                                          {
                                            staticClass: "status-chip",
                                            attrs: {
                                              "x-small": "",
                                              color: _vm.isOrgCompliant(org)
                                                ? "green"
                                                : "red",
                                              "text-color": "white",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.isOrgCompliant(org)
                                                    ? _vm.$t("compliant")
                                                    : _vm.$t("non-compliant")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "phone-count" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(org.totalCount) +
                                                " " +
                                                _vm._s(
                                                  _vm.$t("phone-numbers")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c("v-expansion-panel-content", [
                              org.sipDomain
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "sip-domain-card",
                                      class: {
                                        "sip-domain-error":
                                          !org.sipDomain
                                            .emergencyCallingEnabled ||
                                          !org.sipDomain.emergencyCallerSid,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "sip-domain-header" },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                small: "",
                                                color: _vm.isSipDomainCompliant(
                                                  org.sipDomain
                                                )
                                                  ? "primary"
                                                  : "red",
                                              },
                                            },
                                            [_vm._v("mdi-web")]
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "domain-name" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  org.sipDomain.friendlyName
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "sip-status-chips" },
                                            [
                                              _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    "x-small": "",
                                                    color: org.sipDomain
                                                      .emergencyCallingEnabled
                                                      ? "green"
                                                      : "red",
                                                    "text-color": "white",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        org.sipDomain
                                                          .emergencyCallingEnabled
                                                          ? _vm.$t(
                                                              "e911-enabled"
                                                            )
                                                          : _vm.$t(
                                                              "e911-disabled"
                                                            )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    "x-small": "",
                                                    color: org.sipDomain
                                                      .emergencyCallerSid
                                                      ? "green"
                                                      : "red",
                                                    "text-color": "white",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        org.sipDomain
                                                          .emergencyCallerSid
                                                          ? _vm.$t(
                                                              "caller-id-configured"
                                                            )
                                                          : _vm.$t(
                                                              "no-caller-id"
                                                            )
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      !org.sipDomain.emergencyCallingEnabled ||
                                      !org.sipDomain.emergencyCallerSid
                                        ? _c(
                                            "div",
                                            { staticClass: "sip-errors" },
                                            [
                                              !org.sipDomain
                                                .emergencyCallingEnabled
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "sip-error-item",
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            "x-small": "",
                                                            color: "red",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-close-circle"
                                                          ),
                                                        ]
                                                      ),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "e911-not-enabled"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              !org.sipDomain.emergencyCallerSid
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "sip-error-item",
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            "x-small": "",
                                                            color: "red",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-close-circle"
                                                          ),
                                                        ]
                                                      ),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "emergency-caller-id-not-configured"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "no-sip-domain" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: { small: "", color: "orange" },
                                        },
                                        [_vm._v("mdi-alert")]
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("no-sip-domains"))
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                              _vm.getFilteredWarnings(org).length
                                ? _c(
                                    "div",
                                    { staticClass: "org-warnings" },
                                    _vm._l(
                                      _vm.getFilteredWarnings(org),
                                      function (warning, wIndex) {
                                        return _c(
                                          "div",
                                          {
                                            key: "warning-" + wIndex,
                                            staticClass: "warning-item",
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  small: "",
                                                  color: "orange",
                                                },
                                              },
                                              [_vm._v("mdi-alert")]
                                            ),
                                            _c("span", [
                                              _vm._v(_vm._s(warning)),
                                            ]),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                              _c("div", { staticClass: "phone-statuses" }, [
                                org.phoneNumbers.registered.length
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "status-group registered",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "status-header" },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  small: "",
                                                  color: "green",
                                                },
                                              },
                                              [_vm._v("mdi-check-circle")]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "status-title" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("status-registered")
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-chip",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  color: "green",
                                                  "text-color": "white",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      org.phoneNumbers
                                                        .registered.length
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "phones-grid" },
                                          _vm._l(
                                            org.phoneNumbers.registered,
                                            function (phone) {
                                              return _c(
                                                "div",
                                                {
                                                  key: phone.sid,
                                                  staticClass:
                                                    "phone-item registered",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(phone.phoneNumber)
                                                    ),
                                                  ]),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        "x-small": "",
                                                        color: "red",
                                                        loading:
                                                          _vm.unregisteringPhone ===
                                                          phone.sid,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.confirmUnregister(
                                                            org,
                                                            phone
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            "x-small": "",
                                                          },
                                                        },
                                                        [_vm._v("mdi-link-off")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                org.phoneNumbers.pendingRegistration.length
                                  ? _c(
                                      "div",
                                      { staticClass: "status-group pending" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "status-header" },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  small: "",
                                                  color: "blue",
                                                },
                                              },
                                              [_vm._v("mdi-clock-outline")]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "status-title" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "status-pending-registration"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-chip",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  color: "blue",
                                                  "text-color": "white",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      org.phoneNumbers
                                                        .pendingRegistration
                                                        .length
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "phones-grid" },
                                          _vm._l(
                                            org.phoneNumbers
                                              .pendingRegistration,
                                            function (phone) {
                                              return _c(
                                                "div",
                                                {
                                                  key: phone.sid,
                                                  staticClass:
                                                    "phone-item pending",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(phone.phoneNumber)
                                                    ),
                                                  ]),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        "x-small": "",
                                                        color: "red",
                                                        loading:
                                                          _vm.unregisteringPhone ===
                                                          phone.sid,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.confirmUnregister(
                                                            org,
                                                            phone
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            "x-small": "",
                                                          },
                                                        },
                                                        [_vm._v("mdi-link-off")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                org.phoneNumbers.unregistered.length
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "status-group unregistered",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "status-header" },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  small: "",
                                                  color: "orange",
                                                },
                                              },
                                              [_vm._v("mdi-minus-circle")]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "status-title" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "status-unregistered"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-chip",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  color: "orange",
                                                  "text-color": "white",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      org.phoneNumbers
                                                        .unregistered.length
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "phones-grid" },
                                          _vm._l(
                                            org.phoneNumbers.unregistered,
                                            function (phone) {
                                              return _c(
                                                "div",
                                                {
                                                  key: phone.sid,
                                                  staticClass:
                                                    "phone-item unregistered",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(phone.phoneNumber)
                                                    ),
                                                  ]),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "phone-actions",
                                                    },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            icon: "",
                                                            "x-small": "",
                                                            color: "green",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.openRegisterDialog(
                                                                org,
                                                                phone
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                "x-small": "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-link-plus"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            icon: "",
                                                            "x-small": "",
                                                            color: "red",
                                                            loading:
                                                              _vm.unregisteringPhone ===
                                                              phone.sid,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.confirmUnregister(
                                                                org,
                                                                phone
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                "x-small": "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-link-off"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                org.phoneNumbers.noAddressConfigured.length
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "status-group no-address",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "status-header" },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  small: "",
                                                  color: "red",
                                                },
                                              },
                                              [_vm._v("mdi-map-marker-off")]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "status-title" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "status-no-address-configured"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-chip",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  color: "red",
                                                  "text-color": "white",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      org.phoneNumbers
                                                        .noAddressConfigured
                                                        .length
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "phones-grid" },
                                          _vm._l(
                                            org.phoneNumbers
                                              .noAddressConfigured,
                                            function (phone) {
                                              return _c(
                                                "div",
                                                {
                                                  key: phone.sid,
                                                  staticClass:
                                                    "phone-item no-address",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(phone.phoneNumber)
                                                    ),
                                                  ]),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        "x-small": "",
                                                        color: "green",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.openRegisterDialog(
                                                            org,
                                                            phone
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            "x-small": "",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-link-plus"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                org.phoneNumbers.registrationFailure.length
                                  ? _c(
                                      "div",
                                      { staticClass: "status-group failure" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "status-header" },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  small: "",
                                                  color: "red darken-2",
                                                },
                                              },
                                              [_vm._v("mdi-alert-circle")]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "status-title" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "status-registration-failed"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-chip",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  color: "red darken-2",
                                                  "text-color": "white",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      org.phoneNumbers
                                                        .registrationFailure
                                                        .length
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "phones-grid" },
                                          _vm._l(
                                            org.phoneNumbers
                                              .registrationFailure,
                                            function (phone) {
                                              return _c(
                                                "div",
                                                {
                                                  key: phone.sid,
                                                  staticClass:
                                                    "phone-item failure",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(phone.phoneNumber)
                                                    ),
                                                  ]),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "phone-actions",
                                                    },
                                                    [
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            icon: "",
                                                            "x-small": "",
                                                            color: "green",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.openRegisterDialog(
                                                                org,
                                                                phone
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                "x-small": "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-link-plus"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "action-separator",
                                                        },
                                                        [_vm._v("/")]
                                                      ),
                                                      _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            icon: "",
                                                            "x-small": "",
                                                            color: "red",
                                                            loading:
                                                              _vm.unregisteringPhone ===
                                                              phone.sid,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                              return _vm.confirmUnregister(
                                                                org,
                                                                phone
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                "x-small": "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-link-off"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                org.phoneNumbers.pendingUnregistration.length
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "status-group pending-unreg",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "status-header" },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  small: "",
                                                  color: "grey",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "mdi-clock-alert-outline"
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "status-title" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "status-pending-unregistration"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-chip",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  color: "grey",
                                                  "text-color": "white",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      org.phoneNumbers
                                                        .pendingUnregistration
                                                        .length
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "phones-grid" },
                                          _vm._l(
                                            org.phoneNumbers
                                              .pendingUnregistration,
                                            function (phone) {
                                              return _c(
                                                "div",
                                                {
                                                  key: phone.sid,
                                                  staticClass:
                                                    "phone-item pending-unreg",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(phone.phoneNumber)
                                                    ),
                                                  ]),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        "x-small": "",
                                                        color: "red",
                                                        loading:
                                                          _vm.unregisteringPhone ===
                                                          phone.sid,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.confirmUnregister(
                                                            org,
                                                            phone
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            "x-small": "",
                                                          },
                                                        },
                                                        [_vm._v("mdi-link-off")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                org.phoneNumbers.unregistrationFailure.length
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "status-group unreg-failure",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "status-header" },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  small: "",
                                                  color: "deep-orange",
                                                },
                                              },
                                              [_vm._v("mdi-close-circle")]
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "status-title" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "status-unregistration-failed"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-chip",
                                              {
                                                attrs: {
                                                  "x-small": "",
                                                  color: "deep-orange",
                                                  "text-color": "white",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      org.phoneNumbers
                                                        .unregistrationFailure
                                                        .length
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "phones-grid" },
                                          _vm._l(
                                            org.phoneNumbers
                                              .unregistrationFailure,
                                            function (phone) {
                                              return _c(
                                                "div",
                                                {
                                                  key: phone.sid,
                                                  staticClass:
                                                    "phone-item unreg-failure",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(phone.phoneNumber)
                                                    ),
                                                  ]),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        "x-small": "",
                                                        color: "red",
                                                        loading:
                                                          _vm.unregisteringPhone ===
                                                          phone.sid,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.confirmUnregister(
                                                            org,
                                                            phone
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            "x-small": "",
                                                          },
                                                        },
                                                        [_vm._v("mdi-link-off")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                org.totalCount === 0
                                  ? _c(
                                      "div",
                                      { staticClass: "no-phones" },
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "grey" } },
                                          [_vm._v("mdi-phone-off")]
                                        ),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("no-phone-numbers"))
                                          ),
                                        ]),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]),
                            ]),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _c(
                "div",
                { staticClass: "empty-state" },
                [
                  _c("v-icon", { attrs: { large: "", color: "grey" } }, [
                    _vm._v("mdi-map-marker-question"),
                  ]),
                  _c("span", [_vm._v(_vm._s(_vm.$t("no-data")))]),
                ],
                1
              ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "480",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.unregisterDialog,
            callback: function ($$v) {
              _vm.unregisterDialog = $$v
            },
            expression: "unregisterDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "text-h6" },
                [
                  _c("v-icon", { attrs: { left: "", color: "red" } }, [
                    _vm._v("mdi-link-off"),
                  ]),
                  _vm._v(
                    " " + _vm._s(_vm.$t("remove-emergency-address")) + " "
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: {
                        click: function ($event) {
                          _vm.unregisterDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _vm.unregisterTarget
                ? _c(
                    "v-card-text",
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("confirm-remove-emergency-address")) +
                          " "
                      ),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.unregisterTarget.phone.phoneNumber)),
                      ]),
                      _vm._v("? "),
                      _c("br"),
                      _c("br"),
                      _c("span", { staticClass: "text-caption" }, [
                        _vm._v(
                          _vm._s(_vm.$t("organization")) +
                            ": " +
                            _vm._s(
                              _vm.unregisterTarget.org.organizationName ||
                                _vm.unregisterTarget.org.organizationId
                            )
                        ),
                      ]),
                      _vm.loadingUnregisterAddress
                        ? _c(
                            "div",
                            { staticClass: "text-center py-3" },
                            [
                              _c("v-progress-circular", {
                                attrs: {
                                  indeterminate: "",
                                  color: "red",
                                  size: "20",
                                  width: "2",
                                },
                              }),
                              _c("span", { staticClass: "ml-2 text-caption" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("loading-address-details"))
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm.unregisterAddressDetails
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mt-3 mb-0",
                              attrs: { type: "info", outlined: "", dense: "" },
                            },
                            [
                              _c("div", { staticClass: "address-info" }, [
                                _c(
                                  "div",
                                  { staticClass: "font-weight-medium" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.unregisterAddressDetails
                                            .friendlyName ||
                                            _vm.unregisterAddressDetails
                                              .customerName
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c("div", { staticClass: "text-caption" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.unregisterAddressDetails.street
                                      ) +
                                      ", " +
                                      _vm._s(
                                        _vm.unregisterAddressDetails.city
                                      ) +
                                      ", " +
                                      _vm._s(
                                        _vm.unregisterAddressDetails.region
                                      ) +
                                      " " +
                                      _vm._s(
                                        _vm.unregisterAddressDetails.postalCode
                                      ) +
                                      " "
                                  ),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-caption",
                                    staticStyle: { opacity: "0.7" },
                                  },
                                  [
                                    _vm._v(
                                      " SID: " +
                                        _vm._s(
                                          _vm.unregisterAddressDetails.sid
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        : _vm.unregisterTarget.phone.emergencyAddressSid
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mt-3 mb-0",
                              attrs: {
                                type: "warning",
                                outlined: "",
                                dense: "",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("address-sid")) +
                                  ": " +
                                  _vm._s(
                                    _vm.unregisterTarget.phone
                                      .emergencyAddressSid
                                  ) +
                                  " "
                              ),
                              _c("br"),
                              _c("span", { staticClass: "text-caption" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("could-not-load-address-details")
                                  )
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.unregisterDialog = false
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "red darken-1",
                        dark: "",
                        loading: _vm.unregisteringPhone !== null,
                      },
                      on: { click: _vm.executeUnregister },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("remove")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "500",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.registerDialog,
            callback: function ($$v) {
              _vm.registerDialog = $$v
            },
            expression: "registerDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "text-h6" },
                [
                  _c("v-icon", { attrs: { left: "", color: "green" } }, [
                    _vm._v("mdi-link-plus"),
                  ]),
                  _vm._v(" " + _vm._s(_vm.$t("set-emergency-address")) + " "),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: {
                        click: function ($event) {
                          _vm.registerDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _vm.registerTarget
                ? _c(
                    "v-card-text",
                    [
                      _c("p", [
                        _vm._v(
                          " " + _vm._s(_vm.$t("select-address-for")) + " "
                        ),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.registerTarget.phone.phoneNumber)),
                        ]),
                        _vm._v(": "),
                      ]),
                      _vm.loadingAddresses
                        ? _c(
                            "div",
                            { staticClass: "text-center py-4" },
                            [
                              _c("v-progress-circular", {
                                attrs: {
                                  indeterminate: "",
                                  color: "primary",
                                  size: "24",
                                },
                              }),
                              _c("span", { staticClass: "ml-2" }, [
                                _vm._v(_vm._s(_vm.$t("loading-addresses"))),
                              ]),
                            ],
                            1
                          )
                        : _vm.availableAddresses.length
                        ? _c(
                            "v-radio-group",
                            {
                              staticClass: "address-radio-group",
                              model: {
                                value: _vm.selectedAddressSid,
                                callback: function ($$v) {
                                  _vm.selectedAddressSid = $$v
                                },
                                expression: "selectedAddressSid",
                              },
                            },
                            _vm._l(_vm.availableAddresses, function (addr) {
                              return _c("v-radio", {
                                key: addr.sid,
                                staticClass: "address-radio",
                                attrs: { value: addr.sid },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _c(
                                            "div",
                                            { staticClass: "address-label" },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    addr.friendlyName ||
                                                      addr.customerName
                                                  )
                                                ),
                                              ]),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "address-detail",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(addr.street) +
                                                      ", " +
                                                      _vm._s(addr.city) +
                                                      ", " +
                                                      _vm._s(addr.region) +
                                                      " " +
                                                      _vm._s(addr.postalCode)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              })
                            }),
                            1
                          )
                        : _c(
                            "v-alert",
                            {
                              attrs: {
                                type: "warning",
                                dense: "",
                                outlined: "",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("no-addresses-found")) + " "
                              ),
                            ]
                          ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.registerDialog = false
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "green darken-1",
                        dark: "",
                        loading: _vm.registeringPhone !== null,
                        disabled: !_vm.selectedAddressSid,
                      },
                      on: { click: _vm.executeRegister },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("set-address")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }